import { GESTION_OPERATIVA_ADD_COMMENT } from './constants'

export const saveComments = comments => {
  return dispatch => {
    dispatch({
      type: GESTION_OPERATIVA_ADD_COMMENT,
      data: comments
    })
  }
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_ADD_COMMENT) {
      return {
        ...state,
        commentDrawerOpen: false,
        sale: {
          ...state.sale,
          observation: action.data
        },
         isModified: true
      }
  }
  else {
    return state
  }    
}